var map = {
	"./acougue-color.svg": "3c0f",
	"./agua-color.svg": "25ab",
	"./alimentacao-color.svg": "0a27",
	"./farmacia-color.svg": "cd77",
	"./garrafao-agua-color.svg": "27d6",
	"./informatica-color.svg": "e75d",
	"./lanchonete-color.svg": "2daf",
	"./limpeza-color.svg": "009d",
	"./livraria-color.svg": "b25c",
	"./marmita-color.svg": "5804",
	"./outros-color.svg": "ba2f",
	"./padaria-color.svg": "c15f",
	"./pet-color.svg": "d148",
	"./pizzaria-color.svg": "e615",
	"./restaurant-color.svg": "9382",
	"./saude-color.svg": "21e6",
	"./servicos-color.svg": "25f4",
	"./supermercado-color.svg": "219f",
	"./ver-todos-color.svg": "322c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0e24";